import { contrastChart } from '@iq/react-components';
import { resolveColor, colorOptions } from '../../../../../../colors';

const VECTOR_AXES = [
  { key: 'L1', color: 'blue', fallbackIndex: 0 },
  { key: 'L2', color: 'red', fallbackIndex: 1 },
  { key: 'L3', color: 'green', fallbackIndex: 2 },
];

const CARTESIAN_AXES = [
  { key: 'X', color: 'blue', fallbackIndex: 0 },
  { key: 'Y', color: 'red', fallbackIndex: 1 },
];

function AxisLegendItem({ color, label }) {
  return (
    <div className="star-legend-item">
      <svg
        width="20"
        height="2"
        style={{ marginRight: '0.5rem' }}
      >
        <line
          className="star-legend-axis"
          x1="0"
          y1="50%"
          x2="100%"
          y2="50%"
          stroke={color}
        />
      </svg>
      {label}
    </div>
  );
}

function ThresholdLegendItem({ threshold, type }) {
  const isLinear = type === 'linear';
  const circleProps = isLinear
    ? { stroke: resolveColor(threshold.fill), strokeWidth: 2, fill: 'none' }
    : { fill: resolveColor(threshold.fill), opacity: '50%' };

  return (
    <div className="star-legend-item">
      <svg
        width="10"
        height="10"
        style={{ marginRight: '0.5rem', ...(isLinear ? { overflow: 'visible' } : {}) }}
      >
        <circle
          r="5"
          cx="50%"
          cy="50%"
          {...circleProps}
        />
      </svg>
      {threshold.description}
    </div>
  );
}

export default function StarLegend({
  configuration,
  series,
  legendReference,
  inputMode,
  sortedThresholds = [],
}) {
  const axes = inputMode === 'cartesian' ? CARTESIAN_AXES : VECTOR_AXES;
  const defaultColor = colorOptions[0].value;

  return (
    <div
      className="star-legend"
      ref={legendReference}
    >
      {axes.map(({ key, color, fallbackIndex }) => (
        <AxisLegendItem
          key={key}
          color={color}
          label={
            series.find((s) => s.id === configuration.plot?.[key])?.label ||
            series[fallbackIndex]?.label
          }
        />
      ))}
      <div className="star-legend-item">
        <svg
          width="10"
          height="10"
          style={{ marginRight: '0.5rem' }}
        >
          <rect
            width="10"
            height="10"
            fill={resolveColor(configuration.plot?.color) || defaultColor}
          />
        </svg>
        {configuration.plot?.label}
      </div>
      {configuration.thresholds?.thresholdType === 'linear' &&
        sortedThresholds.map((threshold, index) => (
          <ThresholdLegendItem
            key={index}
            threshold={threshold}
            type="linear"
          />
        ))}
      {configuration.thresholds?.thresholdType === 'area' &&
        sortedThresholds.map((threshold, index) => (
          <ThresholdLegendItem
            key={index}
            threshold={threshold}
            type="area"
          />
        ))}
      {inputMode !== 'cartesian' && configuration.rollingAverage?.show && (
        <div className="star-legend-item">
          <svg
            width="10"
            height="10"
            style={{ marginRight: '0.5rem' }}
          >
            <rect
              width="10"
              height="10"
              fill={resolveColor(configuration.rollingAverage.color) || contrastChart[1]}
            />
          </svg>
          {`Rolling average (${configuration.rollingAverage.decay})`}
        </div>
      )}
    </div>
  );
}
